export const IMAGE_DEFAULT_FOCAL_POINT = {
  x: 0.5,
  y: 0.5
};